var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDiagramRound = function SvgDiagramRound(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "22px",
    viewBox: "0 0 25 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "34416155-2D23-4594-996D-DF9A6F0DD02A") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "DS_Suez_PCE_Atoms",
    transform: "translate(-306.000000, -722.000000)",
    fill: "#030F40"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Assets-/-Icons-/-Bold-/-diagram-round",
    transform: "translate(306.000000, 722.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.1,0.0999960114 C12.30471,0.0999960114 11.66,0.74470996 11.66,1.54 C11.66,2.33529004 12.30471,2.98 13.1,2.98 C16.9730221,2.97806075 20.2946839,5.74289653 20.9955454,9.55197736 C21.6964068,13.3610582 19.5764185,17.1271442 15.9563617,18.503913 C12.3363049,19.8806817 8.24946568,18.4751572 6.242,15.163 C6.19965128,15.0936773 6.19362505,15.0081006 6.22584076,14.9335272 C6.25805647,14.8589538 6.32449697,14.8046827 6.404,14.788 L7.293,14.601 C7.86319262,14.4810069 8.30487559,14.0292171 8.41193986,13.4564561 C8.51900414,12.883695 8.27034582,12.3028621 7.782,11.985 L4.419,9.793 C4.09723738,9.59408781 3.71270083,9.52274522 3.341,9.593 C2.97140019,9.67629377 2.64701086,9.89636407 2.433,10.209 L0.233,13.58 C-0.0521475391,14.0225071 -0.073104249,14.585347 0.178346866,15.0478337 C0.42979798,15.5103204 0.913578079,15.7987381 1.44,15.8 C1.54078538,15.7997311 1.64128923,15.7893457 1.74,15.769 L2.971,15.509 C3.084162,15.4851723 3.1989581,15.5417445 3.249,15.646 C5.55297831,20.5357539 11.0924971,22.9983582 16.2661895,21.4328179 C21.4398819,19.8672776 24.6847155,14.7465605 23.8911504,9.3997611 C23.0975853,4.05296172 18.5053666,0.0954099226 13.1,0.0999960114 Z",
    id: "icon-fill-color"
  }))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDiagramRound);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/diagram-round.2336aed979e03b95b095ca8f57220afe.svg";